import { TranslocoLoader } from '@ngneat/transloco';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<{ [key: string]: string }> {
    return this.http.get<{ [key: string]: string }>(`/assets/i18n/${lang}.json`).pipe(
      catchError((error) => {
        console.error(`Failed to load translation file for language: ${lang}`, error);
        return of({});
      }),
    );
  }
}
